export const cleanNullsAndSort = (obj) => {
  return sortObjectKeys(removeNullValues(obj));
};

const sortObjectKeys = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(sortObjectKeys); // sort elements if it's an array
  }

  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = {};

  sortedKeys.forEach((key) => {
    sortedObj[key] = sortObjectKeys(obj[key]); // recursive sorting
  });

  return sortedObj;
};

const removeNullValues = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj
      .map(removeNullValues) // process elements if it's an array
      .filter((item) => item !== null); // remove nulls from arrays
  }

  const cleanedObj = {};

  Object.keys(obj).forEach((key) => {
    const value = removeNullValues(obj[key]);
    if (value !== null) {
      cleanedObj[key] = value; // only add key if value is not null
    }
  });

  return Object.keys(cleanedObj).length > 0 ? cleanedObj : null;
};

export const removeRawData = (obj) => {
  const { raw_data, ...rest } = obj; // Destructure raw_data out and keep the rest
  return rest;
};
